import React, { useState, useEffect } from "react";
import { Button, Form, Input, Modal, Spin, Select, message } from "antd";
import {
  updateAssignDo,
  getclientslist,
  getDoData,
} from "../../Services/Services";
import { EditOutlined } from "@ant-design/icons";
const LifterAssignUpdate = (props) => {
  const [loading, setLoading] = useState(false);
  const [clientList, setClientList] = useState([]);
  const [lifteruserList, setlifteruserList] = useState([]);
  const [doList, setdoList] = useState([]);
  const [form] = Form.useForm();

  useEffect(() => {
    Getclientslist();
  }, []);

  const Getclientslist = async () => {
    const response = await getclientslist();
    if (response) {
      const filterLifter = response.lifter_user_list.filter(
        (o) => o.com_name === localStorage.getItem("com_name")
      );
      const filterDataClient = response.client_list.filter(
        (o) => o.com_name === localStorage.getItem("com_name")
      );
      setlifteruserList(filterLifter);
      setClientList(filterDataClient);
    }
  };

  useEffect(() => {
    if (props.doData) {
      form.setFieldsValue({
        client_id: props.doData.client_id,
        lifter_id: props.doData.lifter_id,
        do_id: props.doData.do_no,
        Address: props.doData.Address,
        quantity: props.doData.quantity,
        lifting_rate: props.doData.lifting_rate,
        freight_rate: props.doData.freight_rate,
        shortage_rate: props.doData.shortage_rate,
      });
    }
  }, [props.doData, form]);

  const Get_Do_Details = async (id) => {
    const response = await getDoData({
      client_id: id,
      com_name: localStorage.getItem("com_name"),
    });
    form.resetFields(["do_id"]);
    if (response) {
      setdoList(response);
    }
  };

  const Get_Do_Id = async (id) => {
    const quantity = doList.find((do_lis) => do_lis.id === id);
    form.setFieldsValue({
      quantity: quantity.quantity,
    });
  };

const handleCancel = () => {
  props.onClose(); // just notify parent
};
  const onFinish = async (values) => {
    setLoading(true);
    Object.assign(values, {
      com_name: localStorage.getItem("com_name"),
      do_id: props.doData.do_id,
    });
    const response = await updateAssignDo(props.doData.assign_id, values);
    setLoading(false);
    if (response) {
      message.success("DO Assign Update Successful");
      const sortedArray = [...response].sort((a, b) => b.id - a.id);
      props.setassignDetails(sortedArray);
      props.setassignList(sortedArray);
      props.onClose();
      form.resetFields();
    } else {
      message.warning("DO Assign Update Not Successful");
    }
  };

  return (
    <>
      <Modal
        visible={loading} // Correct prop name is visible, not open
        footer={null}
        closable={false}
        width={400}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img
            src="transduniyalogo.png"
            alt="img"
            width={200}
            style={{ margin: "10px" }}
          />
          <Spin />
          <h2>Lifter Do Assign......</h2>
        </div>
      </Modal>

      <Modal
        visible={props.isModalOpen}
        onCancel={props.onClose}
        footer={null}
        destroyOnClose
      >
        <Form form={form} onFinish={onFinish} layout="vertical">
          <div className=" grid grid-cols-1 sm:grid sm:grid-cols-2 sm:gap-2 m-auto px-5 sm:w-[70%]  md:w-[100%] ">
            <Form.Item
              name="lifter_id"
              rules={[
                {
                  required: true,
                  message: "Please Select Lifter Name!",
                },
              ]}
              label={<b>Select Lifter Name</b>}
              style={{ padding: "2px", margin: "2px" }}
            >
              <Select
                showSearch
                placeholder="Search to Select"
                optionFilterProp="children"
                disabled
              >
                {" "}
                {lifteruserList.map((e) => (
                  <Select.Option value={e.id}>{e.name}</Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              name="client_id"
              rules={[
                {
                  required: true,
                  message: "Please Select Party Name!",
                },
              ]}
              label={<b>Select Party Name</b>}
              style={{ padding: "2px", margin: "2px" }}
            >
              <Select
                showSearch
                onChange={Get_Do_Details}
                placeholder="Search to Select"
                optionFilterProp="children"
                disabled
              >
                {" "}
                {clientList.map((client) => (
                  <Select.Option value={client.client_id}>
                    {client.client_name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              name="do_id"
              rules={[
                {
                  required: true,
                  message: "Please Select DO Number!",
                },
              ]}
              label={<b>Select DO No</b>}
              style={{ padding: "2px", margin: "2px" }}
            >
              <Select
                showSearch
                placeholder="Search to Select"
                optionFilterProp="children"
                onChange={Get_Do_Id}
                disabled
              >
                {doList.map((do_i) => (
                  <Select.Option value={do_i.id}>{do_i.do_no}</Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              rules={[
                {
                  required: true,
                  message: "Please Enter Quantity!",
                },
              ]}
              name="quantity"
              label={<b>Quantity</b>}
              style={{ padding: "2px", margin: "2px" }}
            >
              <Input
                placeholder="Quantity"
                type="number"
                size="middle"
                disabled
                style={{ fontWeight: "600", color: "black" }}
              />
            </Form.Item>
            <Form.Item
              rules={[
                {
                  required: true,
                  message: "Please Enter Freight Rate!",
                },
              ]}
              name="freight_rate"
              label={<b>Freight Rate</b>}
              style={{ padding: "2px", margin: "2px" }}
            >
              <Input placeholder="Freight Rate" type="number" size="middle" />
            </Form.Item>
            <Form.Item
              rules={[
                {
                  required: true,
                  message: "Please Enter Shortage Rate!",
                },
              ]}
              name="shortage_rate"
              label={<b>Shortage Rate</b>}
              style={{ padding: "2px", margin: "2px" }}
            >
              <Input placeholder="Shortage Rate" type="number" size="middle" />
            </Form.Item>
            <Form.Item
              rules={[
                {
                  required: true,
                  message: "Please Enter Lifting Rate!",
                },
              ]}
              name="lifting_rate"
              label={<b>Lifting Rate</b>}
              style={{ padding: "2px", margin: "2px" }}
            >
              <Input placeholder="Lifting Rate" type="number" size="middle" />
            </Form.Item>
          </div>
          <Form.Item
            className="text-center"
            style={{ textAlign: "center", marginRight: "40px" }}
          >
            <Button
              htmlType="submit"
              style={{ color: "white", backgroundColor: "black" }}
            >
              Update
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default LifterAssignUpdate;
